import React from 'react';
import '../App.scss';

const RulesAndContact: React.FC = () => {


  return (
    <section id="pravila" className="rules-contact-section">
    <div className="left-column">
      <div className="rules-block">
        <a
          href="/pravila.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
        >
          PRAVILA
        </a>
        <p>Ova Pravila stupaju na snagu danom njihovog donošenja, a prema trećim licima danom javnog objavljivanja u dnevnom listu,
        a nakon dobijanja saglasnosti Ministarstva finansija.</p>
      </div>
      <div className="contact-block">
        <span className="btn-primary">KONTAKT</span>
        <p>MAIL : <a href="mailto:info@ultrachallenge.rs" style={{ textDecoration: 'none' }}>info@ultrachallenge.rs</a></p>
        <p>Broj telefona : <a href="tel:+38163272391" style={{ textDecoration: 'none' }}>063-272-391</a></p>
      </div>
            {/* <p>E-MAIL:</p>
            <p>
              <a href="mailto:info@mosterchallenge.rs" style={{ color: 'inherit', textDecoration: 'none' }}>
                info@mosterchallenge.rs
              </a>
            </p>
            <br />
            <p>Broj telefona:</p>
            <p>
              <a href="tel:+38162395361" style={{ color: 'inherit', textDecoration: 'none' }}>
                062-395-361
              </a>
            </p> */}
    </div>
    <div className="right-column">
      <img src="/ultra-ukusi.png" alt="Ultra proizvodi" className="can-images" />
      <p className="product-note">
      Nagradna igra je otvorena isključivo za lica starija od 18 godina. U nagradnoj igri učestvuju sva pakovanja Ultra Energy limenki od 0,25 L i 0,5 L. Za učešće je potrebno kupiti najmanje jednu Ultra Energy limenku sa promo zatvaračem i uneti kod ispod zatvarača na sajtu www.ultrachallenge.rs. Glavna nagrada je putovanje u Los Anđeles (L.A.). Sve informacije o nagradama, načinu učešća i uslovima nagradne igre dostupne su na web stranici ultrachallenge.rs. Fotografije nagrada su ilustrativnog karaktera. Pažljivo pročitajte pravila nagradne igre objavljena na web stranici.
      </p>
    </div>
  </section>
  );
};

export default RulesAndContact;
